import {AuthContext} from '@/context/Auth/AuthContext'
import {UserRoleContext} from '@/context/UserRole/UserRoleContext'
import {UserRoleProvider} from '@/context/UserRole/UserRoleProvider'
import {Template} from '@/pages/Template'
import {useContext} from 'react'
import {Navigate, Outlet} from 'react-router-dom'
import {ROUTES} from '@/utils/constants/routesConstants'

export const ProtectedRoutes = () => {
  return (
    <UserRoleProvider>
      <Template>
        <ProtectedRoutesContent />
      </Template>
    </UserRoleProvider>
  )
}

const ProtectedRoutesContent = () => {
  const {isReady, isAuthenticated} = useContext(AuthContext)
  const {isAuthorized} = useContext(UserRoleContext)

  if (!isReady) return null
  if (!isAuthenticated) return <Navigate to={ROUTES.LOGIN} replace />

  return isAuthorized ? <Outlet /> : <Outlet />
}
